/*
  common/index.js
    common file of constants, functions, etc...
*/

import moment from 'moment'

// constants
// ----------------------------------------------------------------------------
// application attributes
export const APP_VERSION = '2.7.0'
export let APP_LOG_LEVEL = ''
export let DOC_SERVER_URL = ''
export let TIME_DIFERENCE = 0
switch (process.env.NODE_ENV) {
  case 'production':
    APP_LOG_LEVEL = 'error'
    DOC_SERVER_URL = 'https://heresme.micros-software.com/hm-docs/'
    TIME_DIFERENCE = 9
    break
  case 'devbuild':
    APP_LOG_LEVEL = 'debug'
    DOC_SERVER_URL = 'https://heresme.micros-america.com/hm-docs/'
    TIME_DIFERENCE = 9
    break
  default:
    APP_LOG_LEVEL = 'debug'
    DOC_SERVER_URL = 'https://heresme.micros-america.com/hm-docs/'
    TIME_DIFERENCE = 0
    break
}

export const Languages = [
  '日本語',
  'English',
]

// local storage definition
export const LS_LOGIN_ID = 'hm-login-id'
export const LS_TOKEN_KEY = 'hm-api-token'
export const LS_SECTION_ID = 'hm-section'
export const LS_GROUP_ID = 'hm-group'
//export const LS_SCREEN_VIEW = 'hm-screen-view'
//export const LS_SCREEN_COLUMN = 'hm-screen-column'
export const LS_SCREEN_LAYOUT = 'hm-screen-layout'
export const LS_DISP_ITEM = 'hm-disp-item'
export const LS_CAROUSEL_INTERVAL = 'hm-carousel-interval'

// user menu page name
export const UM_GUIDE_IMG_WEB = 'guide_web.png'
export const UM_GUIDE_IMG_APP = 'guide_app.png'
export const UM_FAQ_IMG_WEB = 'faq_web.png'
export const UM_FAQ_IMG_APP = 'faq_app.png'

// スクリーン表示「レイアウト」選択項目
export const ScreenLayoutLists = [
  {name: '１列', val: '0'},
  {name: '２列', val: '1'},
  {name: 'グリッド', val: '2'},
]
// スクリーン表示「表示項目」選択項目
export const ScreenDispItemLists = [
  {name: '行先リスト', val: '0'},
  {name: 'メモ', val: '1'},
]
// スクリーン表示「切替間隔」選択項目
export const ScreenCarouselIntervalLists = [
  {name: '5秒', val: '5'},
  {name: '10秒', val: '10'},
  {name: '15秒', val: '15'},
  {name: '30秒', val: '30'},
  {name: '60秒', val: '60'},
]

// メニューリスト
export const MenuList = [
  //{id: '001', icon: 'settings', name: 'ユーザ設定'},
  //{id: '002', strkey: 'mylocation', icon: 'location_on', name: '位置情報送信'},
  //{id: '003', strkey: 'notify', icon: 'notifications', name: 'お知らせ', url: ''},
  {id: '004', strkey: 'guide', icon: 'info', name: '使い方ガイド', url: ''},
  {id: '005', strkey: 'faq', icon: 'question_answer', name: 'よくあるご質問', url: ''},
  {id: '006', strkey: 'abouts', icon: 'touch_app', name: 'このアプリについて', url: ''},
  {id: '007', strkey: 'logout', icon: 'reply', name: 'ログアウト', url: ''},
  //{id: '008', strkey: 'manager', icon: '', name: '管理者'},
]
export const UserSubMenuList = [
  {id: '101', strkey: 'passwd', icon: 'security', name: 'パスワード変更'},
  {id: '102', strkey: 'profile', icon: 'account_circle', name: 'プロフィール'},
]
export const BrowserSubMenuList = [
  //{id: '201', strkey: 'mylocation', icon: 'location_on', name: '位置情報送信', type: 'dialog'},
  {id: '202', strkey: 'screenview', icon: 'dvr', name: 'スクリーン表示', type: 'screenSwitch'},
  //{id: '203', strkey: 'columns', icon: '', name: '２列表示', type: 'columnSwitch'},
  {id: '204', strkey: 'screenlayout', icon: '', name: 'レイアウト', type: 'select', list: ScreenLayoutLists},
  {id: '205', strkey: 'dispitem', icon: '', name: '表示項目', type: 'select', list: ScreenDispItemLists},
  {id: '206', strkey: 'interval', icon: '', name: '切替間隔', type: 'select', list: ScreenCarouselIntervalLists},
]
export const AttendanceSubMenuList = [
  {id: '301', strkey: 'telework', icon: 'home_work', name: 'テレワーク勤務', type: 'teleworkSwitch', explain: 'ON(赤)に設定すると、行先情報一覧にテレワーク中を示すアイコンが表示されます。'},
  {id: '302', strkey: 'linkedtw', icon: 'double_arrow', name: '行先入力連動', type: 'linkedTwswitch', explain: 'ON(赤)に設定すると、在席アイコン変更時にテレワーク情報も送信できます。'},
  {id: '303', strkey: 'teleworklist', icon: 'access_time', name: '勤怠データ一覧', type: 'dialog', explain: ''}
]
export const GeolocationSubMenuList = [
  {id: '401', strkey: 'mylocation', icon: 'send', name: '位置情報送信', type: 'monitor'},
  {id: '402', strkey: 'mappos', icon: 'map', name: 'Map位置情報一覧', type: 'admin'},
]
/*export const ManagerSubMenuList = [
  {id: '801', strkey: 'mappos', icon: 'location_on', name: 'Map位置情報一覧'},
]*/

// 勤務時間種別
export const TeleworkCategory = {
  START: 1,
  LEAVE: 2,
  SEATED: 3,
  END: 4
}
export const TeleworkCategoryNames = ['勤務開始', '離席', '着席', '勤務終了']

// 休暇種別
export const HolidayCategory = {
  PAID: 91,       // 有給休暇
  SPECIAL: 92,    // 特別休暇
  SUBSTITUTE: 93, // 代休
  ABSENCE: 94     // 欠勤
}
export const HolidayCategoryNames = ['有給休暇', '特別休暇', '代休', '欠勤']
export const HolidayCategoryNamesShort = ['有休', '特休', '代休', '欠勤']
export const HolidayCategoryDiff = 90

// 連動する勤務種別
export const LinkedWhCategory = {
  START: 1,
  LEAVE: 2,
  END: 4,
  HOLIDAY: 90
}

// functions
// ----------------------------------------------------------------------------
export function formatDate (date, format) {
  if (!format) format = 'YYYY-MM-DD hh:mm:ss'

  format = format.replace(/YYYY/g, date.getFullYear())
  format = format.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2))
  format = format.replace(/DD/g, ('0' + date.getDate()).slice(-2))
  format = format.replace(/hh/g, ('0' + date.getHours()).slice(-2))
  format = format.replace(/mm/g, ('0' + date.getMinutes()).slice(-2))
  format = format.replace(/ss/g, ('0' + date.getSeconds()).slice(-2))
  if (format.match(/S/g)) {
    let milliSeconds = ('00' + date.getMilliseconds()).slice(-3)
    let length = format.match(/S/g).length
    for (var i = 0; i < length; i++) {
      format = format.replace(/S/, milliSeconds.substring(i, i + 1))
    }
  }

  return format
}

// ----------------------------------------------------------------------------
export function getNowDatetime () {
  return new Date()
}

// ----------------------------------------------------------------------------
export function formatDateMoment (date, format) {
  return moment(date).format(format)
}

// ----------------------------------------------------------------------------
export function getNowDatetimeMoment () {
  return moment().format()
}

// ----------------------------------------------------------------------------
// 指定の日時に指定の時間を加算
//  [IN]  date：日時
//        num ：加減する月数(マイナス値を指定すると減算)
//  [OUT] 加減算後の年月(YYYYMM)
export function calcHour (date, num) {
  let ret_date = ''
  if (num > 0) {
    ret_date = moment(date).add(num, 'h').format()
  }
  else {
    ret_date = moment(date).subtract(-num, 'h').format()
  }
  return ret_date
}
// ----------------------------------------------------------------------------
// 指定年月(YYYYMM)から指定の月を加算
//  [IN]  date：YYYYMM
//        num ：加減する月数(マイナス値を指定すると減算)
//  [OUT] 加減算後の年月(YYYYMM)
export function calcMonth (date, num) {
  let ret_date = ''
  if (num > 0) {
    ret_date = moment(date, 'YYYYMM').add(num, 'M').format('YYYYMM')
  }
  else {
    ret_date = moment(date, 'YYYYMM').subtract(-num, 'M').format('YYYYMM')
  }
  return ret_date
}

// ----------------------------------------------------------------------------
// 指定年月(YYYYMM)が何日あるかを返却
//  [IN]  date：YYYYMM
export function getDayInMonth (date) {
  return moment(date, 'YYYYMM').daysInMonth()
}

// ----------------------------------------------------------------------------
// 指定年月日(YYYYMMDD)の曜日を返却
//  [IN]  date：YYYYMMDD
//  [OUT] 曜日(0:日曜日～6:土曜日)
export function getDayOfWeek (date) {
  return moment(date, 'YYYYMMDD').get('day')
}

// ----------------------------------------------------------------------------
// 時間の差分を算出
//  [IN]  from：開始
//        to  ：終了(fromより未来の時間を指定)
//        format：フォーマット
//  [OUT] fromとtoの差分(分)
//        開始＞終了の場合は-1
export function calcDiffTime (from, to, format) {
  let from_date = moment(from, format)
  let to_date = moment(to, format)
  if (from_date > to_date) {
    return -1
  }
  return to_date.diff(from_date, 'm')
}

// ----------------------------------------------------------------------------
export function isNull (value) {
  return (value === null)
}

// ----------------------------------------------------------------------------
export function isUndefined (value) {
  return (value === undefined)
}

// ----------------------------------------------------------------------------
export function isNullorUndefined (value) {
  return (value === undefined || value === null)
}

// ----------------------------------------------------------------------------
export function hmMax (v1, v2) {
  return v1 > v2 ? v1 : v2
}

// ----------------------------------------------------------------------------
export function hmMin (v1, v2) {
  return v1 <= v2 ? v1 : v2
}

// ----------------------------------------------------------------------------
export function checkUserAgent () {
  let result = ''

  const agent = window.navigator.userAgent.toLowerCase()
  const version = window.navigator.appVersion.toLowerCase()

  if (agent.indexOf('msie') > -1) {
    if (version.indexOf('msie 6.') > -1) {
      result = 'IE6'
    }
    else if (version.indexOf('msie 7.') > -1) {
      result = 'IE7'
    }
    else if (version.indexOf('msie 8.') > -1) {
      result = 'IE8'
    }
    else if (version.indexOf('msie 9.') > -1) {
      result = 'IE9'
    }
    else if (version.indexOf('msie 10.') > -1) {
      result = 'IE10'
    }
    else {
      result = 'IExx'
    }
  }
  else if (agent.indexOf('trident/7') > -1) {
    result = 'IE11'
  }
  else if (agent.indexOf('edge') > -1) {
    result = 'edge'
  }
  else if (agent.indexOf('chrome') > -1) {
    result = 'chrome'
  }
  else if (agent.indexOf('safari') > -1) {
    result = 'safari'
  }
  else if (agent.indexOf('opera') > -1) {
    result = 'opera'
  }
  else if (agent.indexOf('firefox') > -1) {
    result = 'firefox'
  }

  return result
}

// ----------------------------------------------------------------------------
export function checkUserAgentForApp () {
  let result = ''

  const agent = window.navigator.userAgent.toLowerCase()
  if (agent.indexOf('iphone') > -1 || agent.indexOf('ipod') > -1) {
    result = 'iPhone'
  }
  else if (agent.indexOf('android') > -1) {
    result = 'Android'
  }

  return result
}

// ----------------------------------------------------------------------------
// 位置情報を取得
//  [IN]  isMobile    : Mobileである場合はtrue
//        isGnssReady : GNSS使用可能の場合はtrue
//  [OUT] 位置情報取得結果
//        result   : 'ok'→取得成功、'ng'→取得失敗
//        lat/lon  : 取得した位置情報。取得できなかった場合は'no data'
//        alertMsg : エラーメッセージ(取得失敗時のみ)
export function getGeoLocation (isMobile, isGnssReady) {
  return new Promise((resolve, reject) => {
    let glResult = {result: 'ok', lat: 'no data', lon: 'no data', alertMsg: ''}

    // Mobileの場合は、GNSSが使用可能か確認
    if (isMobile && !isGnssReady) {
      glResult.result = 'ng'
      glResult.alertMsg = '位置情報機能が利用できません. GPSがONになっていることを確認し、しばらくたってからご利用ください.'
      resolve(glResult)
    }

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          // 取得成功
          //glResult.lat = Number(position.coords.latitude).toFixed(5)
          //glResult.lon = Number(position.coords.longitude).toFixed(5)
          glResult.lat = position.coords.latitude
          glResult.lon = position.coords.longitude
          resolve(glResult)
        },
        (error) => {
          // 取得失敗
          switch (error.code) {
            case error.PERMISSION_DENIED:
              glResult.alertMsg = '位置情報の取得が許可されませんでした.'
              break
            case error.PERMISSION_UNAVAILABLE:
              glResult.alertMsg = '電波状況などで位置情報が取得できませんでした.'
              break
            case error.TIMEOUT:
              glResult.alertMsg = 'タイムアウトしました。GPS機能が有効かご確認ください.'
              break
            default:
              glResult.alertMsg = 'Unknown Error.'
              break
          }
          glResult.result = 'ng'
          glResult.lat = 'no data'
          glResult.lon = 'no data'
          resolve(glResult)
        },
        {
          // オプション
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0
        }
      )
    }
    else {
      glResult.result = 'ng'
      glResult.alertMsg = '位置情報が取得できませんでした.'
      glResult.lat = 'no data'
      glResult.lon = 'no data'
      resolve(glResult)
    }
  })
}

// ----------------------------------------------------------------------------
export function scrollToTop (elmName) {
  let elm = document.getElementById(elmName)
  let scrollY = elm.scrollTop
  return scrollY
  /*let scrolled = (window.pageYOffset !== undefined) ? window.pageYOffset : document.documentElement.scrollTop
  window.scrollTo(0, Math.floor(scrolled / 2))
  return scrolled*/
}



// WEBPACK FOOTER //
// ./src/common/index.js